import { TableColumn } from "react-data-table-component";
import { TFunction } from "i18next";
import { Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../service";

interface UserListTableNameProps {
  image: string;
  name: string;
}

const UserProfile: React.FC<UserListTableNameProps> = ({ image, name }) => {
  return (
    <div className="product-names my-2">
      <div className="media-left">
        <Image
          className="media-object rounded-circle img-40"
          src={dynamicImage(image)}
          alt="organization"
        />
      </div>
      <P>{name}</P>
    </div> 
  );
};

export const AppVersionColumns = (t: TFunction): TableColumn<any>[] => [
  {
    name: t("UserName"),
    cell: (row) => <UserProfile image={row.image} name={row.userName} />,
    sortable: true,
    grow: 2,
  },
  {
    name: t("Role"),
    selector: (row) => row.role,
    sortable: true,
  },
  {
    name: t("OS"),
    selector: (row) => row.os,
    sortable: true,
  },
  {
    name: t("CurrentVersion"),
    selector: (row) => row.currentVersion,
    sortable: true,
  },
  {
    name: t("LatestVersion"),
    selector: (row) => row.latestVersion,
    sortable: true,
  },
];
